import turbolinksLoadedObservable from '@newswebsiteapp/shared/observables/turbolinksLoadedObservable'

turbolinksLoadedObservable.subscribe(() => {
  $('audio,video').mediaelementplayer({
    // enableAutosize: false,
    success(player, node) {
      $(`#${node.id}-mode`).html(`mode: ${player.pluginType}`)
    },
  })
})
